import React, { FC, useState } from "react";
import { Grid, Header, Form, Input, Button, Message } from "semantic-ui-react";
import { IFormField } from "./../types";
import { validator, baseRegisterValidator } from "./../validator";
import { SUBMIT_CLIENT_FORM } from "../../../graphql/query";
import { useMutation } from "@apollo/client";
import Island from "../../../_components/Island";
import { useHistory } from "react-router-dom";

const ClientForm: FC = () => {
  const [submitForm, { loading }] = useMutation(SUBMIT_CLIENT_FORM);

  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [firstName, setFirstName] = useState<IFormField>({
    error: false,
    initial: true,
    value: "",
  });
  const [lastName, setLastname] = useState<IFormField>({
    error: false,
    initial: true,
    value: "",
  });
  const [email, setEmail] = useState<IFormField>({
    error: false,
    initial: true,
    value: "",
  });
  const [phoneNumber, setPhoneNumber] = useState<IFormField>({
    error: false,
    initial: true,
    value: "",
  });

  const [buildingNumber, setBuildingNumber] = useState<IFormField>({
    error: false,
    initial: true,
    value: "",
  });
  const [streetName, setStreetName] = useState<IFormField>({
    error: false,
    initial: true,
    value: "",
  });
  const [landMark, setLandMark] = useState<IFormField>({
    error: false,
    initial: true,
    value: "",
  });
  const [area, setArea] = useState<IFormField>({
    error: false,
    initial: true,
    value: "",
  });
  const [city, setCity] = useState<IFormField>({
    error: false,
    initial: true,
    value: "",
  });
  const [state, setState] = useState<IFormField>({
    error: false,
    initial: true,
    value: "Lagos",
  });

  const history = useHistory();
  const clearForm = () => {
    setFirstName((state) => {
      return {
        ...state,
        value: "",
      };
    });
    setLastname((state) => {
      return {
        ...state,
        value: "",
      };
    });
    setEmail((state) => {
      return {
        ...state,
        value: "",
      };
    });
    setPhoneNumber((state) => {
      return {
        ...state,
        value: "",
      };
    });
    setBuildingNumber((state) => {
      return {
        ...state,
        value: "",
      };
    });
    setStreetName((state) => {
      return {
        ...state,
        value: "",
      };
    });
    setLandMark((state) => {
      return {
        ...state,
        value: "",
      };
    });
    setArea((state) => {
      return {
        ...state,
        value: "",
      };
    });
    setCity((state) => {
      return {
        ...state,
        value: "",
      };
    });
    setState((state) => {
      return {
        ...state,
        value: "",
      };
    });
  };

  const handleFormSubmission = async () => {
    try {
      const { data } = await submitForm({
        variables: {
          data: {
            firstName: firstName.value,
            lastName: lastName.value,
            imageUrl: "",
            email: email.value,
            phoneNumber: `+234${phoneNumber.value}`,
            location: {
              streetName: streetName.value,
              buildingNumber: buildingNumber.value,
              area: area.value,

              landmark: landMark.value,
              city: state.value,
              location: city.value,
            },
          },
        },
      });
      if (data) {
        setSuccess(data.createClientFromAdmin);
      }
      clearForm();
    } catch (error) {
      setError((error as Error).message);
    }
  };
  const clearMessage = () => {
    setSuccess("");
    setError("");
  };

  return (
    <Grid>
      <Grid.Row>
        <Grid.Column width={16}>
          <Island header='Client registration'>
            <Header as='h3'> Personal Information</Header>

            <Form data-testId='client-form'>
              <Form.Group widths='equal'>
                <Form.Input
                  required
                  fluid
                  id='form-subcomponent-shorthand-input-first-name'
                  label='First name'
                  placeholder='First name'
                  value={firstName.value}
                  error={firstName.error}
                  {...(!firstName.initial && {
                    icon: !!validator.validate({
                      firstName: firstName.value.replace(/\s/g, ""),
                    }).error
                      ? {
                          name: "remove",
                          color: "red",
                        }
                      : {
                          name: "check",
                          color: "green",
                        },
                  })}
                  onChange={(e) => {
                    const { value } = e.target;
                    setFirstName((state) => {
                      return {
                        ...state,
                        value,
                        initial: false,
                      };
                    });
                  }}
                  onBlur={() => {
                    const { error } = validator.validate({
                      firstName: firstName.value.replace(/\s/g, ""),
                    });
                    if (error) {
                      setFirstName((state) => {
                        return {
                          ...state,
                          error: {
                            content: "Invalid Name. Please enter a name",
                            pointing: "above",
                          },
                        };
                      });
                    }
                  }}
                  onFocus={() => {
                    setFirstName((state) => {
                      return {
                        ...state,
                        error: false,
                      };
                    });
                    clearMessage();
                  }}
                />
                <Form.Input
                  required
                  fluid
                  id='form-subcomponent-shorthand-input-last-name'
                  label='Last name'
                  placeholder='Last name'
                  {...(!lastName.initial && {
                    icon: !!validator.validate({
                      lastName: lastName.value.replace(/\s/g, ""),
                    }).error
                      ? {
                          name: "remove",
                          color: "red",
                        }
                      : {
                          name: "check",
                          color: "green",
                        },
                  })}
                  value={lastName.value}
                  error={lastName.error}
                  onChange={(e) => {
                    const { value } = e.target;
                    setLastname((state) => {
                      return {
                        ...state,
                        value,
                        initial: false,
                      };
                    });
                  }}
                  onBlur={() => {
                    const { error } = validator.validate({
                      lastName: lastName.value.replace(/\s/g, ""),
                    });
                    if (error) {
                      setLastname((state) => {
                        return {
                          ...state,
                          error: {
                            content: "Invalid Name. Please enter a name",
                            pointing: "above",
                          },
                        };
                      });
                    }
                  }}
                  onFocus={() => {
                    setLastname((state) => {
                      return {
                        ...state,
                        error: false,
                      };
                    });
                    clearMessage();
                  }}
                />
              </Form.Group>
              <Form.Input
                required
                id='form-input-control-error-email'
                control={Input}
                label='Email'
                placeholder='joe@schmoe.com'
                value={email.value}
                error={email.error}
                {...(!email.initial && {
                  icon: !!validator.validate({ email: email.value }).error
                    ? {
                        name: "remove",
                        color: "red",
                      }
                    : {
                        name: "check",
                        color: "green",
                      },
                })}
                onChange={(e) => {
                  const { value } = e.target;
                  setEmail((state) => {
                    return {
                      ...state,
                      value,
                      initial: false,
                    };
                  });
                }}
                onBlur={() => {
                  const { error } = validator.validate({
                    email: email.value,
                  });
                  if (error) {
                    setEmail((state) => {
                      return {
                        ...state,
                        error: {
                          content:
                            "Invalid email. Ensure email is in the right format",
                          pointing: "above",
                        },
                      };
                    });
                  }
                }}
                onFocus={() => {
                  setEmail((state) => {
                    return {
                      ...state,
                      error: false,
                    };
                  });
                  clearMessage();
                }}
              />

              <Form.Field required>
                <label>Phone Number</label>
                <Input
                  label='+234'
                  placeholder='800 000 0001'
                  {...(!phoneNumber.initial && {
                    icon: !!validator.validate({
                      phoneNumber: phoneNumber.value,
                    }).error
                      ? {
                          name: "remove",
                          color: "red",
                        }
                      : {
                          name: "check",
                          color: "green",
                        },
                  })}
                  type='tel'
                  value={phoneNumber.value}
                  error={!!phoneNumber.error}
                  onChange={(e) => {
                    const { value } = e.target;
                    setPhoneNumber((state) => {
                      return {
                        ...state,
                        value: value,
                        initial: false,
                      };
                    });
                  }}
                  onBlur={() => {
                    const { error } = validator.validate({
                      phoneNumber: phoneNumber.value,
                    });
                    if (error) {
                      setPhoneNumber((state) => {
                        return {
                          ...state,
                          error: {
                            content:
                              "Invalid Phone Number. Enter the correct phone number",
                            pointing: "above",
                          },
                        };
                      });
                    }
                  }}
                  onFocus={() => {
                    setPhoneNumber((state) => {
                      return {
                        ...state,
                        error: false,
                      };
                    });
                    clearMessage();
                  }}
                ></Input>
              </Form.Field>

              {/* ================== Location information section ===================== */}

              <Header as='h3'>Address Information</Header>
              <Form.Group widths='equal'>
                <Form.Input
                  required
                  fluid
                  id='form-subcomponent-shorthand-input-first-name'
                  label='House/Flat No'
                  placeholder='123'
                  value={buildingNumber.value}
                  error={buildingNumber.error}
                  {...(!buildingNumber.initial && {
                    icon: !!validator.validate({
                      buildingNumber: buildingNumber.value.replace(/\s/g, ""),
                    }).error
                      ? {
                          name: "remove",
                          color: "red",
                        }
                      : {
                          name: "check",
                          color: "green",
                        },
                  })}
                  onChange={(e) => {
                    const { value } = e.target;
                    setBuildingNumber((state) => {
                      return {
                        ...state,
                        value,
                        initial: false,
                      };
                    });
                  }}
                  onBlur={() => {
                    const { error } = validator.validate({
                      buildingNumber: buildingNumber.value.replace(/\s/g, ""),
                    });
                    if (error) {
                      setBuildingNumber((state) => {
                        return {
                          ...state,
                          error: {
                            content: "Invalid. Enter building number",
                            pointing: "above",
                          },
                        };
                      });
                    }
                  }}
                  onFocus={() => {
                    setBuildingNumber((state) => {
                      return {
                        ...state,
                        error: false,
                      };
                    });
                    clearMessage();
                  }}
                />
                <Form.Input
                  required
                  fluid
                  id='form-subcomponent-shorthand-input-first-name'
                  label='Address Line'
                  placeholder='Harrison Ford Street, Pinnock Beach Estate'
                  value={streetName.value}
                  error={streetName.error}
                  {...(!streetName.initial && {
                    icon: !!validator.validate({
                      streetName: streetName.value.replace(/\s/g, ""),
                    }).error
                      ? {
                          name: "remove",
                          color: "red",
                        }
                      : {
                          name: "check",
                          color: "green",
                        },
                  })}
                  onChange={(e) => {
                    const { value } = e.target;
                    setStreetName((state) => {
                      return {
                        ...state,
                        value,
                        initial: false,
                      };
                    });
                  }}
                  onBlur={() => {
                    const { error } = validator.validate({
                      streetName: streetName.value.replace(/\s/g, ""),
                    });
                    if (error) {
                      setStreetName((state) => {
                        return {
                          ...state,
                          error: {
                            content:
                              "Invalid Name. Please enter your street name",
                            pointing: "above",
                          },
                        };
                      });
                    }
                  }}
                  onFocus={() => {
                    setStreetName((state) => {
                      return {
                        ...state,
                        error: false,
                      };
                    });
                    clearMessage();
                  }}
                />
                <Form.Input
                  required
                  fluid
                  id='form-subcomponent-shorthand-input-first-name'
                  label='Area'
                  placeholder='Osapa London'
                  value={area.value}
                  error={area.error}
                  {...(!area.initial && {
                    icon: !!validator.validate({
                      area: area.value.replace(/\s/g, ""),
                    }).error
                      ? {
                          name: "remove",
                          color: "red",
                        }
                      : {
                          name: "check",
                          color: "green",
                        },
                  })}
                  onChange={(e) => {
                    const { value } = e.target;
                    setArea((state) => {
                      return {
                        ...state,
                        value,
                        initial: false,
                      };
                    });
                  }}
                  onBlur={() => {
                    const { error } = validator.validate({
                      area: area.value.replace(/\s/g, ""),
                    });
                    if (error) {
                      setArea((state) => {
                        return {
                          ...state,
                          error: {
                            content: "Invalid Name. Please enter your area",
                            pointing: "above",
                          },
                        };
                      });
                    }
                  }}
                  onFocus={() => {
                    setArea((state) => {
                      return {
                        ...state,
                        error: false,
                      };
                    });
                    clearMessage();
                  }}
                />
              </Form.Group>

              {/* Area, city, locatiom */}

              <Form.Group widths='equal'>
                <Form.Input
                  required
                  fluid
                  id='form-subcomponent-shorthand-input-first-name'
                  label='City'
                  placeholder='Lekki'
                  value={city.value}
                  error={city.error}
                  {...(!city.initial && {
                    icon: !!validator.validate({
                      city: city.value.replace(/\s/g, ""),
                    }).error
                      ? {
                          name: "remove",
                          color: "red",
                        }
                      : {
                          name: "check",
                          color: "green",
                        },
                  })}
                  onChange={(e) => {
                    clearMessage();
                    const { value } = e.target;
                    setCity((state) => {
                      return {
                        ...state,
                        value,
                        initial: false,
                      };
                    });
                  }}
                  onBlur={() => {
                    const { error } = validator.validate({
                      city: city.value.replace(/\s/g, ""),
                    });
                    if (error) {
                      setCity((state) => {
                        return {
                          ...state,
                          error: {
                            content: "Invalid Name. Please enter your city",
                            pointing: "above",
                          },
                        };
                      });
                    }
                  }}
                  onFocus={() => {
                    setCity((state) => {
                      return {
                        ...state,
                        error: false,
                      };
                    });
                    clearMessage();
                  }}
                />
                <Form.Input
                  fluid
                  id='form-subcomponent-shorthand-input-first-name'
                  label='Landmark'
                  placeholder='Muson Center'
                  value={landMark.value}
                  onChange={(e) => {
                    const { value } = e.target;
                    setLandMark((state) => {
                      return {
                        ...state,
                        value,
                        initial: false,
                      };
                    });
                  }}
                  onFocus={() => {
                    setLandMark((state) => {
                      return {
                        ...state,
                        error: false,
                      };
                    });
                    clearMessage();
                  }}
                />
                <Form.Field>
                  <label htmlFor='state'>State</label>
                  <input id='state' readOnly value={state.value} />
                </Form.Field>
              </Form.Group>

              {success !== "" && (
                <Message
                  success
                  header='Created successfully'
                  content={success}
                />
              )}
              {error !== "" && <Message error header='Error' content={error} />}
              <div>
                <Button basic color='red' onClick={() => history.goBack()}>
                  Back
                </Button>
                {!loading ? (
                  <Button
                    primary
                    {...(baseRegisterValidator.validate({
                      firstName: firstName.value.replace(/\s/g, ""),
                      lastName: lastName.value.replace(/\s/g, ""),
                      email: email.value,
                      phoneNumber: phoneNumber.value,
                      streetName: streetName.value.replace(/\s/g, ""),
                      buildingNumber: buildingNumber.value,

                      city: city.value.replace(/\s/g, ""),
                      area: area.value.replace(/\s/g, ""),
                      state: state.value.replace(/\s/g, ""),
                    }).error && { disabled: true })}
                    onClick={() => {
                      handleFormSubmission();
                    }}
                  >
                    Submit
                  </Button>
                ) : (
                  <Button loading primary>
                    Loading
                  </Button>
                )}
              </div>
            </Form>
          </Island>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};
export default ClientForm;
